import * as React from "react";
import DataTable, {
    customValueRenderer,
    booleanValueRenderer,
    nonFilterableColumn,
    dropDownColumn,
    columnWidth,
    freeTextColumn,
} from "../../components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { EditRecordDialog } from "../../components/RecordDialog";
import { BooleanField, StringMapField, TextField } from "../../components/Form";
import { setReportClients } from "../../store/reports";

// Fields that the user is allowed to edit per API client
const EDIT_FIELDS = [
    {
        name: "name",
        label: "Name",
        type: TextField,
        required: true,
    },
    {
        name: "allow_historic_dates",
        label: "Allow Historic Dates?",
        type: BooleanField,
        required: true,
    },
    {
        name: "permissions",
        label: "Permissions",
        type: StringMapField,
        required: true,
        keyTitle: "Report Type",
        valueTitle: "Columns (comma separated)",
        formatValue: (list) => list.join(", "),
        parseValue: (text) => text.split(",").map((s) => s.trim()),
        parseKey: (text) => text.trim(),
        keyWidthPercent: 25,
    },
];

const convertPermissions = (permissions) =>
    Object.fromEntries(
        Object.entries(permissions).map(([k, v]) => [k, v.columns]),
    );

export default function APIClients() {
    const dispatch = useDispatch();
    const reportClients = useSelector((state) => state.reports.reportClients);
    const apiClients = reportClients.map(
        (c) => ({ ...c, permissions: convertPermissions(c.permissions) }),
    );
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [editRowIndex, setEditRowIndex] = useState(0);

    const renderPermissions = (x) => {
        if (!x) return "N/A";
        // Show only the report types the API clients is permitted to use
        return Object.keys(x).join(", ");
    };

    const TABLE_COLUMNS = [
        nonFilterableColumn("name", "Name"),
        dropDownColumn("allow_historic_dates", "Allow Historic Dates?", {
            ...booleanValueRenderer(),
            ...columnWidth("50px"),
        }),
        freeTextColumn(
            "permissions",
            "Permissions (Report Types)",
            customValueRenderer(renderPermissions),
        ),
    ];

    const TABLE_OPTIONS = {
        viewColumns: false,
        sortOrder: {
            name: "name",
            direction: "asc",
        },
        onEditRow: (index) => {
            setEditRowIndex(index);
            setShowEditDialog(true);
        },
    };

    const onFinishedEditingRow = async (updatedRecord) => {
        dispatch(
            setReportClients(
                reportClients.map((c) =>
                    c._id === updatedRecord._id ? updatedRecord : c,
                ),
            ),
        );
        setShowEditDialog(false);
    };

    return (
        <>
            <EditRecordDialog
                title="Edit API Client"
                show={showEditDialog}
                fields={EDIT_FIELDS}
                record={apiClients[editRowIndex]}
                updateAPIPath={"api_client"}
                onCancelled={() => setShowEditDialog(false)}
                onFinished={onFinishedEditingRow}
                maxWidth="lg"
            />
            <DataTable
                title={"API Clients"}
                data={apiClients}
                columns={TABLE_COLUMNS}
                options={TABLE_OPTIONS}
            />
        </>
    );
}
